export enum Variant {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum Color {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  QUARTERNARY = 'quarternary',
}
